var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41732 16.5834V3.41675C9.41732 2.16675 8.88398 1.66675 7.55898 1.66675H4.19232C2.86732 1.66675 2.33398 2.16675 2.33398 3.41675V16.5834C2.33398 17.8334 2.86732 18.3334 4.19232 18.3334H7.55898C8.88398 18.3334 9.41732 17.8334 9.41732 16.5834Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.1673 9.08341V3.41675C18.1673 2.16675 17.634 1.66675 16.309 1.66675H12.9423C11.6173 1.66675 11.084 2.16675 11.084 3.41675V9.08341C11.084 10.3334 11.6173 10.8334 12.9423 10.8334H16.309C17.634 10.8334 18.1673 10.3334 18.1673 9.08341Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.1673 16.5833V14.25C18.1673 13 17.634 12.5 16.309 12.5H12.9423C11.6173 12.5 11.084 13 11.084 14.25V16.5833C11.084 17.8333 11.6173 18.3333 12.9423 18.3333H16.309C17.634 18.3333 18.1673 17.8333 18.1673 16.5833Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0124ee46517ba0cb1cd4a9272c974a25.svg";
export { ForwardRef as ReactComponent };